import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import ImageLoader from '../image-loader';
import ExternalLink from '../../components/external-link';
import { getCurrentLocationOuterUrl } from '../../selectors/location-history-selectors';
import getImageUrl from '../../services/get-image-url';
import formatUrl from '../../services/format-url';
import styles from './text-editor-image.scss';

export class TextEditorImage extends Component {
  renderLoader = isLoading => {
    if (!isLoading) {
      return null;
    }
    return <ImageLoader/>;
  };

  render = () => {
    const { block, contentState, className, isPublic, url } = this.props;
    const entity = contentState.getEntity(block.getEntityAt(0));
    const { src, isLoading, href } = entity.getData();
    const link = formatUrl(href);
    const ContainerComponent = link ? ExternalLink : 'div';
    const containerProps = {
      ...getElementProps(this.props),
      ...(link ? { href: link } : {}),
    };
    let imageSrc = src.dataUrl;

    if (!imageSrc) {
      imageSrc = getImageUrl(src);
    }

    const containerClassName = classNames(className, styles.container, 'text-editor-image', {
      [styles.isLoading]: isLoading,
    });
    const imgProps = (isPublic && url) ? { 'data-pin-url': url } : { 'data-pin-nopin': true };
    return (
      <ContainerComponent {...containerProps} className={containerClassName} draggable data-hook="image">
        <img className={styles.image} src={imageSrc} {...imgProps}/>
        {this.renderLoader(isLoading)}
      </ContainerComponent>
    );
  };
}

function getElementProps(props) {
  return _.omit(props, [
    'block',
    'blockProps',
    'contentState',
    'customStyleMap',
    'customStyleFn',
    'decorator',
    'forceSelection',
    'offsetKey',
    'tree',
    'theme',
    'direction',
    'selection',
    'url',
    'dispatch',
    'isPublic',
  ]);
}

TextEditorImage.propTypes = {
  block: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
  contentState: PropTypes.object,
  className: PropTypes.string,
  url: PropTypes.string,
  isPublic: PropTypes.bool,
};

const mapStateToProps = state => ({
  url: getCurrentLocationOuterUrl(state),
});

export default connect(mapStateToProps)(TextEditorImage);



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-image.js